import { CONFIRMATION_MODAL_OPEN, CONFIRMATION_MODAL_CLOSE } from './ConfirmationModalActions';

const initialState = {
  openConfirmations: [],
};

const confirmationModalReducer = (state = initialState, { type, ...action }) => {
  switch (type) {
    case CONFIRMATION_MODAL_OPEN:
      return {
        ...state,
        openConfirmations: [...state.openConfirmations, action.confirmationModalID],
      };
    case CONFIRMATION_MODAL_CLOSE:
      return {
        ...state,
        openConfirmations: state.openConfirmations.slice(0, state.openConfirmations.length - 1),
      };
    default:
      return state;
  }
};

export default confirmationModalReducer;
